import React, { useEffect } from "react";
import { useNavBlocker } from "./useNavBlocker";
import { useBlocker, useLocation, useNavigate } from "react-router";

interface UnloadBlockerProps {
    block: boolean;
}

var globalBlock = false;

export default function UnloadBlocker(props: UnloadBlockerProps) {

    const location = useLocation();

    useEffect(() => {
        if (props.block) {
            globalBlock = true;
        } else {
            globalBlock = false;
        }
        return () => {
            globalBlock = false;
        }
    }, [location, props.block]);
    

    useEffect(() => {
        window.addEventListener("beforeunload", onBlock);
        return () => {
            window.removeEventListener("beforeunload", onBlock);
        }

    })

    function onBlock(e: BeforeUnloadEvent): void {
        if (props.block) {
            e.preventDefault();
            e.returnValue = "";
        }
    }

    return <></>;
}

interface SafeNavigate {
    (link: string): void;
}

interface UseSafeNavigate {
    (navigate: (link: string) => void): SafeNavigate;
}

export function useSafeNavigate(navigate: (link: string) => void): SafeNavigate {
    return (link: string) => {
        if(globalBlock) {
            if (window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
                globalBlock = false;
                navigate(link);
            }
        } else {
            navigate(link);
        }
    };
}